// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-214f793e]{position:relative}.search-wrapper .results-wrapper[data-v-214f793e]{position:absolute;top:100%;left:0;width:100%;background-color:var(--bg-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
